import Vue from "vue";
import VueRouter from "vue-router";
import index from "../views/Index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect:"/index"
  },
  {
    // 直达首页锚点路由
    path: "/:anchor(llxx|ddjs|hscc)",
    redirect: (to) => `/index/${to.params.anchor}`
  },
  {
    path: "/index", // 首页
    name: "index",
    component: index 
  },
  {
    path: "/index/:id",
    name: "index1",
    component: index 
  },
  {
    path: "/infiniteLoop", // 
    name: "infiniteLoop",
    component: () =>
      import(/* webpackChunkName: "ImportFunc" */ "../views/15-infinite-loop.vue")
  },
  {
    path: "/partyLanguage", // 党言党语
    name: "partyLanguage",
    component: () =>
      import(/* webpackChunkName: "ImportFunc" */ "../views/PartyLanguage.vue")
  },
  {
    path: "/result", // 文献检索结果页
    name: "result",
    component: () =>
      import(/* webpackChunkName: "ImportFunc" */ "../views/search/Result.vue")
  },
  {
    path: "/result/:activeName/:uid", // 文献检索结果页
    name: "result1",
    component: () =>
      import(/* webpackChunkName: "ImportFunc" */ "../views/search/Result.vue")
  },
  {
    path: "/more/:uid/:breadcrumb", // 党史二级页的文献更多页
    name: "more",
    component: () =>
      import(/* webpackChunkName: "ImportFunc" */ "../views/More.vue")
  },
  {
    path: "/qa", // 智能问答检索结果页
    name: "qa",
    component: () =>
      import(/* webpackChunkName: "ImportFunc" */ "../views/search/QA.vue")
  },
  {
    path: "/detail/:id", //接收params传来的id
    name: "detail",
    component: () =>
      import(/* webpackChunkName: "ImportFunc" */ "../views/Detail.vue")
  },
  {
    path: "/dnfg", //党章党规-党内法规查看更多
    name: "dnfg",
    component: () =>
      import(/* webpackChunkName: "ImportFunc" */ "../views/DnfgMore.vue")
  },
  {
    path: "/DzdgPage/:id", // 中国共产党章程
    name: "dzdgpage",
    component: () =>
      import(/* webpackChunkName: "ImportFunc" */ "../views/DzdgPage.vue")
  },
  {
    path: "/DdConstruct/:activeName", // 党的建设查看更多二级页
    name: "ddConstruct1",
    component: () =>
      import(/* webpackChunkName: "ImportFunc" */ "../views/DdConstruct.vue")
  },
  {
    path: "/Djsx", // 党的建设查看更多二级页
    name: "djsx",
    component: () =>
      import(/* webpackChunkName: "ImportFunc" */ "../views/DJSX.vue")
  },
  {
    path: "/DdConstruct", // 党的建设查看更多二级页
    name: "ddConstruct",
    component: () =>
      import(/* webpackChunkName: "ImportFunc" */ "../views/DdConstruct.vue")
  },
  {
    path: "/DnjzhdPage", // 党内集中教育活动二级页
    name: "dnjzhdpage",
    component: () =>
      import(/* webpackChunkName: "ImportFunc" */ "../views/DnjzhdPage.vue")
  },
  {
    path: "/DnjzhdPage/:id", // 党内集中教育活动二级页
    name: "dnjzhdpage1",
    component: () =>
      import(/* webpackChunkName: "ImportFunc" */ "../views/DnjzhdPage.vue")
  },
  {
    path: "/DsxxPage/:activeName", // 党史人物查看更多二级页
    name: "dsxxPage",
    component: () =>
      import(/* webpackChunkName: "ImportFunc" */ "../views/DsxxPage.vue")
  },
  {
    path: "/DsxxXqy/:type/:activeName/:index/:uid", // 党史人物详情页
    name: "dsxxXqy",
    component: () =>
      import(/* webpackChunkName: "ImportFunc" */ "../views/DsxxXqy.vue")
  },
  {
    path: "/NewfilePage/:uid/:columnName", // 党章党规最新文件和党内法规查看更多二级页
    name: "newfilePage",
    component: () =>
      import(/* webpackChunkName: "ImportFunc" */ "../views/NewfilePage.vue")
  },
  {
    path: "/SubjectPage", // 更多专题页
    name: "subjectpage",
    component: () =>
      import(/* webpackChunkName: "ImportFunc" */ "../views/SubjectPage.vue")
  },
  {
    path: "/InheritanceMore/:type", // 更多红色传承页
    name: "InheritanceMore",
    component: () =>
      import(/* webpackChunkName: "ImportFunc" */ "../views/InheritanceMore.vue")
  },
  {
    path: "/LidaiParty", // 历次党代会
    name: "lidaiParty",
    redirect:"/LidaiParty/BgqwPage20",
    component: () => import(/* webpackChunkName: "ImportFunc" */ "../views/Mettings/LidaiParty.vue"),
    children:[
      {
        path:'BgqwPage20',
        name:'bgqwPage20',
        component:() =>
        import('../views/Mettings/lcddh/BgqwPage20.vue'),
      },
      {
        path:'BgqwPage19',
        name:'bgqwPage19',
        component:() =>
        import('../views/Mettings/lcddh/BgqwPage19.vue'),
      },
      {
        path:'BgqwPage18',
        name:'bgqwPage18',
        component:() =>
        import('../views/Mettings/lcddh/BgqwPage18.vue'),
      },
      {
        path:'BgqwPage17',
        name:'bgqwPage17',
        component:() =>
        import('../views/Mettings/lcddh/BgqwPage17.vue'),
      },
      {
        path:'MeetDetail16',
        name:'meetDetail16',
        component:() =>
        import('../views/Mettings/lcddh/MeetDetail16.vue'),
      },
      {
        path:'BgqwPage16',
        name:'bgqwPage16',
        component:() =>
        import('../views/Mettings/lcddh/BgqwPage16.vue'),
      },
      {
        path:'BgqwPage15',
        name:'bgqwPage15',
        component:() =>
        import('../views/Mettings/lcddh/BgqwPage15.vue'),
      },
      {
        path:'BgqwPage14',
        name:'bgqwPage14',
        component:() =>
        import('../views/Mettings/lcddh/BgqwPage14.vue'),
      },
      {
        path:'BgqwPage13',
        name:'bgqwPage13',
        component:() =>
        import('../views/Mettings/lcddh/BgqwPage13.vue'),
      },
      {
        path:'BgqwPage12',
        name:'bgqwPage12',
        component:() =>
        import('../views/Mettings/lcddh/BgqwPage12.vue'),
      },
      {
        path:'MeetDetail16',
        name:'meetDetail161',
        component:() =>
        import('../views/Mettings/lcddh/MeetDetail16.vue'),
      },
      {
        path:'MeetDetail15',
        name:'meetDetail15',
        component:() =>
        import('../views/Mettings/lcddh/MeetDetail15.vue'),
      },
      {
        path:'MeetDetail14',
        name:'meetDetail14',
        component:() =>
        import('../views/Mettings/lcddh/MeetDetail14.vue'),
      },
      {
        path:'MeetDetail13',
        name:'meetDetail13',
        component:() =>
        import('../views/Mettings/lcddh/MeetDetail13.vue'),
      },
      {
        path:'MeetDetail12',
        name:'meetDetail12',
        component:() =>
        import('../views/Mettings/lcddh/MeetDetail12.vue'),
      },
      {
        path:'MeetDetail11',
        name:'meetDetail11',
        component:() =>
        import('../views/Mettings/lcddh/MeetDetail11.vue'),
      },
      {
        path:'MeetDetail10',
        name:'meetDetail10',
        component:() =>
        import('../views/Mettings/lcddh/MeetDetail10.vue'),
      },
      {
        path:'MeetDetail9',
        name:'meetDetail9',
        component:() =>
        import('../views/Mettings/lcddh/MeetDetail9.vue'),
      },
      {
        path:'MeetDetail8',
        name:'meetDetail8',
        component:() =>
        import('../views/Mettings/lcddh/MeetDetail8.vue'),
      },
      {
        path:'MeetDetail7',
        name:'meetDetail7',
        component:() =>
        import('../views/Mettings/lcddh/MeetDetail7.vue'),
      },
       {
        path:'MeetDetail6',
        name:'meetDetail6',
        component:() =>
        import('../views/Mettings/lcddh/MeetDetail6.vue'),
      },
      {
        path:'MeetDetail5',
        name:'meetDetail5',
        component:() =>
        import('../views/Mettings/lcddh/MeetDetail5.vue'),
      },
      {
        path:'MeetDetail4',
        name:'meetDetail4',
        component:() =>
        import('../views/Mettings/lcddh/MeetDetail4.vue'),
      },
      {
        path:'MeetDetail3',
        name:'meetDetail3',
        component:() =>
        import('../views/Mettings/lcddh/MeetDetail3.vue'),
      },
      {
        path:'MeetDetail2',
        name:'meetDetail2',
        component:() =>
        import('../views/Mettings/lcddh/MeetDetail2.vue'),
      },
      {
        path:'MeetDetail1',
        name:'meetDetail1',
        component:() =>
        import('../views/Mettings/lcddh/MeetDetail1.vue'),
      },
     
      {
        path:'Literature/:index/:activeName',
        name:'Literature',
        component:() =>
        import('../views/Mettings/Literature.vue'),
      },
      
    ]
  },
  {
    path: "/QuanHuiParty", // 十九大以来的历次全会
    name: "quanHuiParty",
    redirect:"/QuanHuiParty/HYGB7",
    component: () => import(/* webpackChunkName: "ImportFunc" */ "../views/Mettings/QuanHuiParty.vue"),
    children:[
      {
        path:'HYGB1',
        name:'HYGB1',
        component:() =>
        import('../views/Mettings/sjdyldlcqh/HYGB1.vue'),
      },
      {
        path:'HYGB2',
        name:'HYGB2',
        component:() =>
        import('../views/Mettings/sjdyldlcqh/HYGB2.vue'),
      },
      {
        path:'HYGB3',
        name:'HYGB3',
        component:() =>
        import('../views/Mettings/sjdyldlcqh/HYGB3.vue'),
      },
      {
        path:'HYGB4',
        name:'HYGB4',
        component:() =>
        import('../views/Mettings/sjdyldlcqh/HYGB4.vue'),
      },
      {
        path:'HYGB5',
        name:'HYGB5',
        component:() =>
        import('../views/Mettings/sjdyldlcqh/HYGB5.vue'),
      },
      {
        path:'HYGB6',
        name:'HYGB6',
        component:() =>
        import('../views/Mettings/sjdyldlcqh/HYGB6.vue'),
      },
      {
        path:'HYGB7',
        name:'HYGB7',
        component:() =>
        import('../views/Mettings/sjdyldlcqh/HYGB7.vue'),
      },
      {
        path:'Literature/:uid/:activeName',
        name:'Literature1',
        component:() =>
        import('../views/Mettings/Literature.vue'),
      },
      
    ]
  },
  {
    path: "/app", // 智能问答检索结果页
    name: "app",
    component: () =>
        import(/* webpackChunkName: "ImportFunc" */ "../views/APP/index.vue")
  },
  {
    path: "/appIframe", // 智能问答检索结果页
    name: "appIframe",
    component: () =>
        import(/* webpackChunkName: "ImportFunc" */ "../views/APP/appIframe.vue")
  },
  {
    path: "/xjp", // 智能问答检索结果页
    name: "xjp",
    component: () =>
        import(/* webpackChunkName: "ImportFunc" */ "../views/APP/xjp.vue")
  },
];

const router = new VueRouter({
  //上传服务器用
  // mode:"history", //去除访问地址中# 打包时要注释掉
  // base:"/HistoryCommunistPartyChina_VUE2106/", //如果项目根目录不为域名，则添加该行 外层文件名

  routes
});

//路由不匹配或者路径错误，跳转首页的方法
router.beforeEach((to,from,next)=>{
  if(to.matched.length === 0){//匹配前往的路由不存在
    from.name ? next({
      name: from.name
    }) : next('/index'); //判断此跳转路由的来源路由是否存在，存在就跳转到来源路由，否则跳转首页
  }else{
    next();//如果匹配到正确跳转
  }
});

export default router;
